// extracted by mini-css-extract-plugin
module.exports = {"mask":"VideoSection_mask__mYHjQ","copyContainer":"VideoSection_copyContainer__eoUmD","eyebrow":"VideoSection_eyebrow__xehIP","heading":"VideoSection_heading__aanc3"};